// (() => {
//     let t = e => {
//         let a;
//         (a = (document.currentScript ? document.currentScript.parentElement : e).querySelector(".popular-products__slider")) && new IntersectionObserver(e => {
//             e.forEach(t => {
//                 if (t.isIntersecting) {
//                     var t = a.parentElement.querySelector(".popular-products__navigation"),
//                         r = a.querySelector(".popular-products__pagination"),
//                         s = Number(a.dataset.columns),
//                         n = s,
//                         i = 4 <= s ? n - 1 : n,
//                         o = 3 <= s ? 3 : n,
//                         l = 2 <= s ? 2 : o;
//                     let e = 1;
//                     a.classList.contains("products--2-mobile") && (e = 1 < s ? 2 : 1);
//                     new Swiper(a, {
//                         slidesPerView: e,
//                         slidesPerGroup: e,
//                         spaceBetween: 8,
//                         speed: 800,
//                         mousewheel: {
//                             forceToAxis: !0
//                         },
//                         navigation: {
//                             nextEl: t.querySelector(".swiper-button-next"),
//                             prevEl: t.querySelector(".swiper-button-prev")
//                         },
//                         pagination: {
//                             el: r,
//                             type: "custom",
//                             renderCustom: function(e, t, r) {
//                                 let s = "";
//                                 for (let e = 1; e < r + 1; e++) s = e == t ? `${s}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>` : `${s}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
//                                 return s
//                             }
//                         },
//                         breakpoints: {
//                             576: {
//                                 slidesPerView: l,
//                                 slidesPerGroup: l,
//                                 centeredSlides: true,
//                                 loop: true,
//                                 spaceBetween: 8
//                             },
//                             750: {
//                                 slidesPerView: 1,
//                                 slidesPerGroup: o,
//                                 spaceBetween: 8
//                             },
//                             990: {
//                                 slidesPerView: i,
//                                 slidesPerGroup: i,
//                                 spaceBetween: 8
//                             },
//                             1200: {
//                                 slidesPerView: n,
//                                 slidesPerGroup: n,
//                                 spaceBetween: 24
//                             },
//                             1600: {
//                                 slidesPerView: s,
//                                 slidesPerGroup: s,
//                                 spaceBetween: 24
//                             }
//                         }
//                     })
//                 }
//             })
//         }).observe(e || document.currentScript.parentElement)
//     };
//     t(), document.addEventListener("shopify:section:load", function(e) {
//         t(e.target)
//     })
// })();








  (() => {
    let t = e => {
        let a;
        (a = (document.currentScript ? document.currentScript.parentElement : e).querySelector(".popular-products__slider")) && new IntersectionObserver(e => {
            e.forEach(t => {
                if (t.isIntersecting) {
                    var t = a.parentElement.querySelector(".popular-products__navigation"),
                        r = a.querySelector(".popular-products__pagination"),
                        s = Number(a.dataset.columns),
                        n = s,
                        i = 4 <= s ? n - 1 : n,
                        o = 3 <= s ? 3 : n,
                        l = 2 <= s ? 2 : o;
                    let e = 1;
                    a.classList.contains("products--2-mobile") && (e = 1 < s ? 2 : 1);
                    new Swiper(a, {
                        slidesPerView: e,
                        slidesPerGroup: e,
                        spaceBetween: 8,
                        speed: 800,
                        mousewheel: {
                            forceToAxis: !0
                        },
                        navigation: {
                            nextEl: t.querySelector(".swiper-button-next"),
                            prevEl: t.querySelector(".swiper-button-prev")
                        },
                        pagination: {
                            el: r,
                            type: "custom",
                            renderCustom: function(e, t, r) {
                                let s = "";
                                for (let e = 1; e < r + 1; e++) s = e == t ? `${s}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>` : `${s}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                                return s
                            }
                        },
                        breakpoints: {
                          0: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        centeredSlides: true,
        loop: true,
        spaceBetween: 8
    },
                            750: {
                                slidesPerView: 1,
                                slidesPerGroup: o,
                                spaceBetween: 8
                            },
                            990: {
                                slidesPerView: i,
                                slidesPerGroup: i,
                                spaceBetween: 8
                            },
                            1200: {
                                slidesPerView: n,
                                slidesPerGroup: n,
                                spaceBetween: 24
                            },
                            1600: {
                                slidesPerView: s,
                                slidesPerGroup: s,
                                spaceBetween: 24
                            }
                        }
                    })
                }
            })
        }).observe(e || document.currentScript.parentElement)
    };
    t(), document.addEventListener("shopify:section:load", function(e) {
        t(e.target)
    })
})();